export const systemEs = {
  // LegalPage
  'system.legal.fallbackTitle': 'Documento',
  'system.legal.fallbackBody': 'No encontrado.',
  'system.legal.lastUpdated': 'Última actualización {date}',

  // NotFoundPage
  'system.notFound.seoTitle': 'Perdido en el Velo',
  'system.notFound.heading': 'Has vagado más allá del borde del mapa',
  'system.notFound.body': 'El camino que buscabas ha sido engullido por el crepúsculo eterno.',
  'system.notFound.returnCta': 'Volver al Velo',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'Una perturbación desconocida sacudió el velo.',
  'system.error.seoTitle': 'Una Perturbación en el Velo',
  'system.error.heading': 'El ritual se desmoronó',
  'system.error.body':
    'Algo invisible interrumpió esta página. El velo es frágil aquí — inténtalo de nuevo, o vuelve a tierra más segura.',
  'system.error.tryAgain': 'Intentar de Nuevo',
  'system.error.returnCta': 'Volver al Velo',
  'licenseGate.heading': "Próximamente — restringido por licencia",
  'licenseGate.body': "Esta edición en tu idioma aún no está disponible por motivos de licencia. Está en camino: vuelve pronto.",
} as const
